(function () {
    'use strict';

    angular
        .module('financial')
        .controller('RevenueReportController', RevenueReportController);

    RevenueReportController.$inject = ['ExpoService', '$uibModal', 'ngDialog', 'RevenueCostBreakdownService'];


    function RevenueReportController(ExpoService,$uibModal, ngDialog, RevenueCostBreakdownService) {
        var vm                   = this;
        vm.flag                  = false;
        vm.expanded              = false;
        vm.costFairAdvertising   =  {};  
        vm.widget                = [];
        vm.cityLength            = 1;   
        vm.expo                  = [];
        vm.expoSelected          = '';
        vm.semesterSelected      = [];
        vm.revenue               = [];   
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.selectSemester        = selectSemester;
        vm.getRevenueFirstLevel  = getRevenueFirstLevel;
        vm.getInvoiceWidget      = getInvoiceWidget;        
        vm.getSummary           = getSummary;

        vm.getByFilter  = getByFilter;        

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            vm.selectSemester();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpoBySemester () {
            ExpoService.getExpoBySemester(vm.semesterSelected).then(function(response){
                vm.expo = response.data;                 

                // Remove High School tour, for while.
                // let i = vm.expo.length;
                // while (i--) {
                //     if (vm.expo[i].is_school_visit == 1) {
                //         vm.expo.splice(vm.expo.indexOf(vm.expo[i]), 1);
                //     }
                // }
            }).catch(function(err) {
            });
        }

        function selectSemester () {
            ExpoService.getSemesters().then(function(response){
                vm.semester = response.data;
            }).catch(function(err) {
            });
        }
        
        function getRevenueFirstLevel () {
            vm.revenue = [];
            vm.cityLength = 1;
            RevenueCostBreakdownService.getRevenueFirstLevel(vm.query).then(function(response){
                
                vm.revenue = response.data;
                console.log(vm.revenue);
                // vm.cityLength = Object.keys(vm.revenue['cities_th']).length + 3;
            }).catch(function(err) {
            });
        }        
            
        function getInvoiceWidget () {
            vm.widget = [];
            RevenueCostBreakdownService.getInvoiceWidget(vm.query).then(function(response){
                vm.widget = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }        

        function getSummary () {
            
            vm.summary = [];
            vm.summaryFlag = false;
            let query = {};
            
            if( typeof vm.expoSelected.id !== 'undefined') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if( typeof vm.semesterSelected.semester !== 'undefined') {
                query['semester'] = vm.semesterSelected.semester;
            }
            RevenueCostBreakdownService.getWidgetSummary(query).then(function(response){
                vm.summaryFlag = true;
                vm.summary = response.data;
            }).catch(function(err) {
            });
        }

    
        function getByFilter () {
            vm.flag         = false;
            vm.query        = {};
            
            if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
            }
            if( vm.expoSelected && vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            vm.query['page'] = vm.page;
            vm.goalsFlag = false;
            this.getRevenueFirstLevel();
            this.getInvoiceWidget();
            this.getSummary();
        }

        activate();
    }

})();